module.exports = __webpack_public_path__ + "static/media/warning.79d1f1c0.svg";